import qs from 'qs';
import { RouteComponentProps } from 'react-router-dom';
import EmailVerificationResultComponent from '../../components/auth/EmailVerificationResultComponent';

function EmailVerificationResultContainer({ history }: RouteComponentProps) {
  const { verified, redirectUrl } = qs.parse(window.location.search, {
    ignoreQueryPrefix: true,
  });

  const moveToSignInPage = () => {
    if (redirectUrl === 'undefined') {
      history.push('/login');
    } else {
      history.push(`/${redirectUrl}?redirectUrl=${redirectUrl}` as string);
    }
  };

  return (
    <>
      {verified && (
        <EmailVerificationResultComponent
          verified={verified as string}
          // redirectUrl={redirectUrl as string}
          moveToSignInPage={moveToSignInPage}
        />
      )}
    </>
  );
}
export default EmailVerificationResultContainer;
